// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: var(--ion-color-light);
}

.pins {
  column-count: 2;
  gap: 0;
  padding: 8px;
}
.pins .pin {
  width: -webkit-fill-available;
  width: -moz-available;
  width: stretch;
  display: inline-block;
  background: white;
  border-radius: 6px;
  padding: 20px;
  margin: 8px;
  cursor: pointer;
}

.title {
  margin-bottom: 0;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ion-color-light);
}
.title h1 {
  font-weight: 600;
  padding-bottom: 5px;
}
.title h6 {
  font-size: 14px !important;
  margin-top: 10px;
  color: var(--ion-color-medium);
}
.title h6 ion-text {
  font-weight: 600;
  font-size: 14px !important;
}

ion-label {
  margin-bottom: 0 !important;
  margin: 0;
  padding: 0;
}
ion-label p {
  font-size: 13px;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 5px;
  color: #a6a9ab;
}
ul li {
  font-size: 12px !important;
}

.clock {
  height: fit-content;
}

.product {
  --padding-start: 0;
  margin-right: -10px;
}
.product .name {
  width: 33%;
  min-width: 33%;
  max-width: 33%;
  font-size: 12px !important;
}
.product .price {
  width: 33%;
  min-width: 33%;
  max-width: 33%;
  text-align: right;
  font-size: 12px !important;
}
.product .quantity {
  width: 33%;
  min-width: 33%;
  max-width: 33%;
  text-align: right;
  font-size: 12px !important;
}

.empty-data {
  height: 90vh;
}

.data {
  display: flex;
  align-items: center;
  padding-top: 16px;
}
.data p {
  margin-left: auto;
}

.total {
  border-bottom: 1px solid var(--ion-color-light);
  padding-bottom: 16px;
}
.total ion-label {
  font-size: 19px !important;
  font-weight: 600;
  margin: 0;
  padding: 0;
}
.total p {
  font-size: 19px;
  font-weight: 600;
  color: var(--ion-color-dark);
}

.user-lbl {
  border: none;
  padding-top: 16px;
  padding-bottom: 0;
}
.user-lbl h6 {
  margin-top: 0;
  font-size: 13px !important;
}
.user-lbl h6 ion-text {
  font-size: 13px !important;
}

.small {
  --border-radius: 6px;
  --padding-top: 0;
  --padding-start: 0.9em;
  --padding-end: 0.9em;
  --padding-bottom: 0;
  height: 2.1em;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/payments/ticket-selection/ticket-selection.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,YAAA;AACF;AACE;EACE,6BAAA;EAAA,qBAAA;EAAA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AACJ;;AAGA;EACE,gBAAA;EACA,oBAAA;EACA,+CAAA;AAAF;AAEE;EACE,gBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,0BAAA;EACA,gBAAA;EACA,8BAAA;AADJ;AAGI;EACE,gBAAA;EACA,0BAAA;AADN;;AAMA;EACE,2BAAA;EACA,SAAA;EACA,UAAA;AAHF;AAKE;EACE,eAAA;AAHJ;;AAOA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AAJF;AAME;EACE,0BAAA;AAJJ;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,kBAAA;EACA,mBAAA;AALF;AAOE;EACE,UAAA;EACA,cAAA;EACA,cAAA;EACA,0BAAA;AALJ;AAQE;EACE,UAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,0BAAA;AANJ;AASE;EACE,UAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,0BAAA;AAPJ;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AARF;AAUE;EACE,iBAAA;AARJ;;AAYA;EACE,+CAAA;EACA,oBAAA;AATF;AAWE;EACE,0BAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AATJ;AAYE;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;AAVJ;;AAcA;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;AAXF;AAaE;EACE,aAAA;EACA,0BAAA;AAXJ;AAaI;EACE,0BAAA;AAXN;;AAgBA;EACE,oBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AAbF","sourcesContent":["ion-content {\n  --background: var(--ion-color-light);\n}\n\n.pins {\n  column-count: 2;\n  gap: 0;\n  padding: 8px;\n\n  .pin {\n    width: stretch;\n    display: inline-block;\n    background: white;\n    border-radius: 6px;\n    padding: 20px;\n    margin: 8px;\n    cursor: pointer;\n  }\n}\n\n.title {\n  margin-bottom: 0;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--ion-color-light);\n\n  h1 {\n    font-weight: 600;\n    padding-bottom: 5px;\n  }\n\n  h6 {\n    font-size: 14px !important;\n    margin-top: 10px;\n    color: var(--ion-color-medium);\n\n    ion-text {\n      font-weight: 600;\n      font-size: 14px !important;\n    }\n  }\n}\n\nion-label {\n  margin-bottom: 0 !important;\n  margin: 0;\n  padding: 0;\n\n  p {\n    font-size: 13px;\n  }\n}\n\nul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  margin-top: 5px;\n  color: #a6a9ab;\n\n  li {\n    font-size: 12px !important;\n  }\n}\n\n.clock {\n  height: fit-content;\n}\n\n.product {\n  --padding-start: 0;\n  margin-right: -10px;\n\n  .name {\n    width: 33%;\n    min-width: 33%;\n    max-width: 33%;\n    font-size: 12px !important;\n  }\n\n  .price {\n    width: 33%;\n    min-width: 33%;\n    max-width: 33%;\n    text-align: right;\n    font-size: 12px !important;\n  }\n\n  .quantity {\n    width: 33%;\n    min-width: 33%;\n    max-width: 33%;\n    text-align: right;\n    font-size: 12px !important;\n  }\n}\n\n.empty-data {\n  height: 90vh;\n}\n\n.data {\n  display: flex;\n  align-items: center;\n  padding-top: 16px;\n\n  p {\n    margin-left: auto;\n  }\n}\n\n.total {\n  border-bottom: 1px solid var(--ion-color-light);\n  padding-bottom: 16px;\n\n  ion-label {\n    font-size: 19px !important;\n    font-weight: 600;\n    margin: 0;\n    padding: 0;\n  }\n\n  p {\n    font-size: 19px;\n    font-weight: 600;\n    color: var(--ion-color-dark);\n  }\n}\n\n.user-lbl {\n  border: none;\n  padding-top: 16px;\n  padding-bottom: 0;\n\n  h6 {\n    margin-top: 0;\n    font-size: 13px !important;\n\n    ion-text {\n      font-size: 13px !important;\n    }\n  }\n}\n\n.small {\n  --border-radius: 6px;\n  --padding-top: 0;\n  --padding-start: 0.9em;\n  --padding-end: 0.9em;\n  --padding-bottom: 0;\n  height: 2.1em;\n  font-size: 13px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
